import { stringify } from 'qs';

export function getQuery(filters = {}) {
    return stringify(filters, {
        arrayFormat: 'repeat',
        addQueryPrefix: true,
        filter: (prefix, value) => !['offset', 'limit'].includes(prefix) && value ? value : undefined,
    });
}
